import React, { useEffect, useState } from "react";
import "./Banner.css";
import AudioService from "./services/AudioService";

function Banner({ onPlayClick, onInfoClick }) {
  const [audiobook, setAudiobook] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchFeaturedAudiobook() {
      setIsLoading(true);
      try {
        const featured = await AudioService.getFeaturedAudiobook();
        setAudiobook(featured);
      } catch (error) {
        console.error("Error fetching featured audiobook:", error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchFeaturedAudiobook();
  }, []);

  const handlePlayClick = () => {
    if (onPlayClick && audiobook) {
      onPlayClick({ ...audiobook, type: 'audiobook' });
    }
  };

  const handleInfoClick = () => {
    if (onInfoClick && audiobook) {
      onInfoClick({ ...audiobook, type: 'audiobook' });
    }
  };

  // Placeholder while loading
  if (isLoading) {
    return (
      <header className="banner banner--loading">
        <div className="banner__contents">
          <div className="banner__skeleton-title"></div>
          <div className="banner__skeleton-buttons"></div>
          <div className="banner__skeleton-description"></div>
        </div>
        <div className="banner--fadeBottom" />
      </header>
    );
  }

  // Fixed hero background image (WebP optimized)
  const backgroundImage = `url("/hero-bg.webp")`;

  return (
    <header
      className="banner"
      style={{
        backgroundSize: "cover",
        backgroundImage: backgroundImage,
        backgroundPosition: "center center",
      }}
    >
      <div className="banner__overlay" />

      <div className="banner__contents">
        <h1 className="banner__title">
          {audiobook?.title || 'Loading...'}
        </h1>

        <div className="banner__meta">
          {audiobook?.authors?.length > 0 && (
            <span className="banner__author">
              {audiobook.authors.join(', ')}
            </span>
          )}
          {audiobook?.totalTimeFormatted && (
            <span className="banner__duration">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
              </svg>
              {audiobook.totalTimeFormatted}
            </span>
          )}
          {audiobook?.numSections > 0 && (
            <span className="banner__chapters">
              {audiobook.numSections} chapters
            </span>
          )}
        </div>

        <div className="banner__buttons">
          <button className="banner__button banner__button--play" onClick={handlePlayClick}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 2.69127C4 1.93067 4.81547 1.44851 5.48192 1.81506L22.4069 11.1238C23.0977 11.5037 23.0977 12.4963 22.4069 12.8762L5.48192 22.1849C4.81546 22.5515 4 22.0693 4 21.3087V2.69127Z" fill="currentColor"/>
            </svg>
            Listen
          </button>
          <button className="banner__button banner__button--info" onClick={handleInfoClick}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM13 10V18H11V10H13ZM12 8.5C12.8284 8.5 13.5 7.82843 13.5 7C13.5 6.17157 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5Z" fill="currentColor"/>
            </svg>
            More Info
          </button>
        </div>
      </div>

      <div className="banner--fadeBottom" />
    </header>
  );
}

export default Banner;
